import DecodePage from './DecodePage';

export default DecodePage;
